<template>
  <div>
    <title>Zenfiny | List Leads</title>
    <div
      class="w-full bg-secondary py-2 lg:flex justify-between items-center px-3 lg:px-24"
    >
      <h1 class="text-white text-lg lg:text-2xl font-bold">
        <i class="fas fa-file mr-2"></i>
        LIST LEADS
      </h1>
      <div class="grid grid-cols-2 gap-4 mt-3 lg:mt-0">
        <button
          class="text-sm lg:text-md font-medium btn-search inline-block lg:px-2 py-2 font-regular leading-tight uppercase rounded shadow-md hover:shadow-lg focus:bg-white focus:outline-none focus:ring-0 active:bg-white active:shadow-lg transition duration-150 ease-in-out rounded-full"
          data-bs-toggle="collapse"
          data-bs-target="#collapseExample"
          aria-expanded="false"
          aria-controls="collapseExample"
        >
          <i class="fas fa-search color-text mx-3"></i> SEARCH FILTER
        </button>
      </div>
    </div>

    <!-- contenido del Collapse -->
    <div class="collapse mt-2" id="collapseExample">
      <div class="block p-6 rounded-lg shadow-lg bg-color">
        <div class="form-group mb-6">
          <label
            for="nameLisForm"
            class="form-label inline-block mb-2 color-grey font-regular px-3 text-md lg:text-xl"
            >Name</label
          >
          <input
            v-model="search_provisional_name"
            type="text"
            class="form-control block w-full px-3 py-2 text-sm font-normal t ext-gray-700 bg-white border-4 border-solid border-white rounded-full transition ease-in-out m-0 focus:text-gray-700 focus:border-gray-400 focus:outline-none"
            id="nameLisForm"
            placeholder=""
          />
        </div>
        <div class="form-group mb-6">
          <label
            for="codeLisForm"
            class="form-label inline-block mb-2 color-grey font-regular px-3 text-md lg:text-xl"
            >Email</label
          >
          <input
            v-model="search_provisional_email"
            type="text"
            class="form-control block w-full px-3 py-2 text-sm font-normal text-gray-700 bg-white border-4 border-solid border-white rounded-full transition ease-in-out m-0 focus:text-gray-700 focus:border-gray-400 focus:outline-none"
            id="codeLisForm"
            placeholder=""
          />
        </div>

        <div class="form-group mb-6">
          <label
            for="codeLisForm"
            class="form-label inline-block mb-2 color-grey font-regular px-3 text-md lg:text-xl"
            >Type</label
          >
          <select
            v-model="search_provisional_type"
            type="dropdown"
            class="form-control block w-full px-3 py-2 text-sm font-normal text-gray-700 bg-white border-4 border-solid border-white rounded-full transition ease-in-out m-0 focus:text-gray-700 focus:border-gray-400 focus:outline-none"
            id="codeLisForm"
            placeholder=""
          >
            <option value="2"></option>
            <option value="0">Calculator</option>
            <option value="1">Form Quote</option>
          </select>
        </div>

        <div class="flex justify-end">
          <button
            v-on:click.stop.prevent="setSearch()"
            class="btn-primary inline-block px-2 py-2 font-regular text-sm leading-tight uppercase rounded shadow-md hover:shadow-lg focus:bg-purple-600 focus:outline-none focus:ring-0 active:bg-white active:shadow-lg transition duration-150 ease-in-out rounded-full lg:w-2/12"
            type="button"
          >
            <i class="fas fa-search color-black mx-1"></i> SEARCH
          </button>
        </div>
      </div>
    </div>
    <!--end collapse-->

    <div class="py-2 inline-block min-w-full sm:px-6 lg:px-8">
      <div class="overflow-hidden">
        <table class="min-w-full">
          <thead class="bg-primary border-b-2">
            <tr>
              <th
                scope="col"
                class="text-sm font-regular text-white px-2 py-2 text-left"
              >
                Name
              </th>
              <th
                scope="col"
                class="text-sm font-regular text-white px-2 py-2 text-left"
              >
                Type
              </th>
              <th
                scope="col"
                class="text-sm font-regular text-white px-2 py-2 text-left"
              >
                Origin
              </th>
              <th
                scope="col"
                class="text-sm font-regular text-white px-2 py-2 text-left"
              >
                Email
              </th>

              <th
                scope="col"
                class="text-sm font-regular text-white px-2 py-2 text-left"
              >
                Phone
              </th>
              <th
                scope="col"
                class="text-sm font-regular text-white px-2 py-2 text-left"
              >
                Loan
              </th>

              <th
                scope="col"
                class="text-sm font-regular text-white px-2 py-2 text-left"
              >
                Business name
              </th>
              <th
                scope="col"
                class="text-sm font-regular text-white px-2 py-2 text-center"
              >
                Info
              </th>
              <th
                scope="col"
                class="text-sm font-regular text-white px-2 py-2 text-center"
              >
                Quote create
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="lead in leads"
              v-bind:key="lead.id"
              class="bg-white border-b transition duration-300 ease-in-out hover:bg-gray-100"
            >
              <td class="text-sm font-semibold px-2 py-2 whitespace-nowrap">
                {{ lead.name }}
              </td>

              <td
                v-if="lead.type == 0"
                class="text-sm font-semibold px-2 py-2 whitespace-nowrap"
              >
                Calculator
              </td>

              <td
                v-else
                class="text-sm font-semibold px-2 py-2 whitespace-nowrap"
              >
                Form Quote
              </td>

              <td
                v-if="lead.form_id"
                class="text-sm px-2 py-2 whitespace-nowrap"
              >
                {{ lead.form.name }}
              </td>

              <td v-else class="text-sm px-2 py-2 whitespace-nowrap"></td>

              <td class="text-sm px-2 py-2 whitespace-nowrap">
                {{ lead.email }}
              </td>
              <td class="text-sm px-2 py-2 whitespace-nowrap">
                {{ lead.phone }}
              </td>
              <td class="text-sm px-2 py-2 whitespace-nowrap">
                {{ lead.loan }}
              </td>
              <td class="text-sm px-2 py-2 whitespace-nowrap">
                {{ lead.bussines_name }}
              </td>
              <td
                class="text-md text-center font-medium px-2 py-2 whitespace-nowrap"
              >
                <button
                  @click="openModal(lead.id)"
                  type="button"
                  class="inline-block py-2 font-medium text-md leading-tight color-black transition duration-150 ease-in-out"
                >
                  <i class="fas fa-info color-grey"></i>
                </button>
              </td>
              <td
                class="text-md text-center font-medium px-2 py-2 whitespace-nowrap"
              >
                <button
                  @click="quoteCreate(lead.id)"
                  type="button"
                  class="inline-block py-2 font-medium text-md leading-tight color-black transition duration-150 ease-in-out"
                >
                  <i class="fas fa-plus color-grey"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!--PAGINATION-->
    <div aria-label="Page navigation" class="bg-transparent pb-4">
      <div class="flex flex-col mt-5">
        <ul class="inline-flex flex justify-center">
          <li>
            <button
              @click="getLeads(current_page - 1)"
              :disabled="current_page == 1"
              class="h-10 px-5 text-black transition-colors duration-150 bg-white border border-r-0 border-black rounded-l-lg focus:shadow-outline hover:bg-indigo-100"
            >
              <svg class="w-4 h-4 fill-current" viewBox="0 0 20 20">
                <path
                  d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                  fill-rule="evenodd"
                ></path>
              </svg>
            </button>
          </li>
          <li v-if="current_page > 1">
            <button
              @click="getLeads(1)"
              :disabled="current_page == 1"
              class="h-10 px-5 text-black transition-colors duration-150 bg-white border border-r-0 border-black focus:shadow-outline"
            >
              1
            </button>
          </li>
          <li v-if="current_page > 2">
            <button
              disabled
              class="h-10 px-5 text-black transition-colors duration-150 bg-white border border-r-0 border-black focus:shadow-outline"
            >
              ...
            </button>
          </li>

          <li>
            <button
              disabled
              class="h-10 px-5 text-white transition-colors duration-150 bg-primary border border-r-0 border-black focus:shadow-outline"
            >
              {{ current_page }}
            </button>
          </li>

          <li v-if="current_page < last_page - 1">
            <button
              disabled
              class="h-10 px-5 text-black transition-colors duration-150 bg-white border border-r-0 border-black focus:shadow-outline"
            >
              ...
            </button>
          </li>
          <li v-if="current_page < last_page">
            <button
              @click="getLeads(last_page)"
              class="h-10 px-5 text-black transition-colors duration-150 bg-white border border-r-0 border-black focus:shadow-outline"
            >
              {{ last_page }}
            </button>
          </li>

          <li>
            <button
              @click="getLeads(current_page + 1)"
              :disabled="current_page == last_page"
              class="h-10 px-5 text-black transition-colors duration-150 bg-white border border-black rounded-r-lg focus:shadow-outline hover:bg-indigo-100"
            >
              <svg class="w-4 h-4 fill-current" viewBox="0 0 20 20">
                <path
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clip-rule="evenodd"
                  fill-rule="evenodd"
                ></path>
              </svg>
            </button>
          </li>
        </ul>
      </div>
    </div>
    <!--END PAGINATION-->

    <!--MODAL-->

    <!-- The Modal -->
    <div id="myModal" class="modal">
      <!-- Modal content -->
      <div class="modal-content rounded-xl">
        <div
          class="w-full bg-secondary py-2 lg:flex justify-between items-center px-6 rounded-t-xl"
        >
          <h2 class="text-white text-xl font-bold text-center">
            <i class="fas fa-file"></i>
            LEAD INFO
          </h2>
          <span class="close" @click="closeModal">&times;</span>
        </div>
        <div v-if="current_lead != null">
          <div class="bg-white w-full h-full rounded-b-xl">
            <div class="p-4 m-auto">
              <p class="font-medium text-md leading-10">
                <b>Name: </b>{{ this.current_lead.name }}
              </p>
              <p class="font-medium text-md leading-10">
                <b>Email: </b>{{ this.current_lead.email }}
              </p>
              <p class="font-medium text-md leading-10">
                <b>Telephone: </b>{{ this.current_lead.phone }}
              </p>

              <p class="font-medium text-md leading-10">
                <b>Loan: </b>{{ this.current_lead.loan }}
              </p>
              <p class="font-medium text-md leading-10">
                <b>Business name: </b>{{ this.current_lead.bussines_name }}
              </p>
              <p class="font-medium text-md leading-10">
                <b>Notifications: </b
                >{{ this.current_lead.marketing == 0 ? "No" : "Yes" }}
              </p>
              <p class="font-medium text-md leading-10">
                <b>Receive information: </b
                >{{ this.current_lead.custom_comunications == 0 ? "No" : "Yes" }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--END MODAL-->
  </div>
</template>

<style scoped>
/* The Modal (background) */
.modal {
  display: none;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 1;
  /* Sit on top */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
}

/* Modal Content/Box */
.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  /* 15% from the top and centered */
  border: 1px solid #888;
  width: 50%;
  /* Could be more or less, depending on screen size */
}

/* The Close Button */
.close {
  color: #ffffff;
  float: right;
  font-size: 43px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
</style>

<script>
import LeadService from "../../services/af-quote/LeadService";

export default {
  data() {
    return {
      search_query: null,
      leads: null,
      search_name: null,
      search_type: null,
      search_email: null,
      search_provisional_name: null,
      search_provisional_type: null,
      search_provisional_email: null,
      current_page: null,
      last_page: null,
      current_lead: null,
    };
  },

  async created() {
    await this.getLeads();
  },

  methods: {
    async openModal(lead_id) {
      var lead_service = new LeadService();
      const lead_response = await lead_service.getLead(lead_id);
      this.current_lead = lead_response.lead;
      var modal = document.getElementById("myModal");
      modal.style.display = "block";
    },
    closeModal() {
      var modal = document.getElementById("myModal");
      modal.style.display = "none";
    },
    infoLead(id) {
      console.log("info lead modal: ", id);
      this.$router.replace({
        name: "infolead",
        params: {
          id: id,
        },
      });
    },
    quoteCreate(id) {
      console.log("quote create modal: ", id);
      this.$router.replace({
        name: "registerQuoteLead",
        params: {
          id: id,
        },
      });
    },
    async getLeads(num_page = null) {
      if (num_page != null) {
        this.setSearch(num_page);
      }
      const lead_service = new LeadService();
      if (this.search_query == null) {
        const lead_data = await lead_service.getLeads();
        this.leads = lead_data.lead.data;
        this.current_page = lead_data.lead.current_page;
        this.last_page = lead_data.lead.last_page;
      } else {
        const lead_data = await lead_service.getLeads(this.search_query);
        this.leads = lead_data.lead.data;
        this.current_page = lead_data.lead.current_page;
        this.last_page = lead_data.lead.last_page;
      }
      console.log(this.leads);
    },
    async setSearch(num_page = null) {
      this.search_type = this.search_provisional_type;
      if (this.search_provisional_type == 2) {
        this.search_type = null;
      }
      this.search_name = this.search_provisional_name;
      this.search_email = this.search_provisional_email;
      this.search_query = null;

      if (num_page != null) {
        this.search_query = "?page=" + num_page;
      }

      if (this.search_name != null && this.search_name != "") {
        this.search_query = "?name=" + this.search_name;
      }

      if (
        this.search_name != null &&
        this.search_name != "" &&
        num_page != null
      ) {
        this.search_query = "?page=" + num_page + "&name=" + this.search_name;
      }

      //eee
      if (this.search_type != null && this.search_type != "") {
        this.search_query = "?type=" + this.search_type;
      }

      if (
        this.search_type != null &&
        this.search_type != "" &&
        num_page != null
      ) {
        this.search_query = "?page=" + num_page + "&type=" + this.search_type;
      }
      //aaaa

      if (this.search_email != null && this.search_email != "") {
        this.search_query = "?email=" + this.search_email;
      }

      if (
        this.search_email != null &&
        this.search_email != "" &&
        num_page != null
      ) {
        this.search_query = "?page=" + num_page + "&email=" + this.search_email;
      }

      if (this.search_name != null && this.search_email != null) {
        this.search_query =
          "?name=" + this.search_name + "&email=" + this.search_email;
      }
      if (this.search_type != null && this.search_email != null) {
        this.search_query =
          "?type=" + this.search_type + "&email=" + this.search_email;
      }
      if (this.search_type != null && this.search_name != null) {
        this.search_query =
          "?type=" + this.search_type + "&name=" + this.search_name;
      }
      if (
        this.search_name != null &&
        this.search_email != null &&
        this.search_type != null
      ) {
        this.search_query =
          "?name=" +
          this.search_name +
          "&email=" +
          this.search_email +
          "&type=" +
          this.search_type;
      }

      if (
        this.search_name != null &&
        this.search_email != null &&
        num_page != null
      ) {
        this.search_query =
          "?page=" +
          num_page +
          "&name=" +
          this.search_name +
          "&email=" +
          this.search_email;
      }
      if (
        this.search_type != null &&
        this.search_email != null &&
        num_page != null
      ) {
        this.search_query =
          "?page=" +
          num_page +
          "&type=" +
          this.search_type +
          "&email=" +
          this.search_email;
      }
      if (
        this.search_type != null &&
        this.search_name != null &&
        num_page != null
      ) {
        this.search_query =
          "?page=" +
          num_page +
          "&type=" +
          this.search_type +
          "&name=" +
          this.search_name;
      }
      if (
        this.search_name != null &&
        this.search_email != null &&
        this.search_type != null &&
        num_page != null
      ) {
        this.search_query =
          "?page=" +
          num_page +
          "&name=" +
          this.search_name +
          "&email=" +
          this.search_email +
          "&type=" +
          this.search_type;
      }
      if (num_page == null) {
        await this.getLeads();
      }
    },
  },
};
</script>
